module.exports = __webpack_public_path__ + "assets/7ee3c9c4f9c943823f23e879b533a7e4.mp3";